import { render, staticRenderFns } from "./EditOrigCourtCase.vue?vue&type=template&id=aec1cb8a&"
import script from "./EditOrigCourtCase.vue?vue&type=script&lang=js&"
export * from "./EditOrigCourtCase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports